const GTM_URL = 'https://www.googletagmanager.com';
export const getJavascriptSnippet = (containerId, url = GTM_URL, consentMode) => {
  const consentScript = consentMode ? 'window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag("consent","default",{ad_personalization:"denied",ad_storage:"denied",ad_user_data:"denied",analytics_storage:"denied",wait_for_update:2000});gtag("set","ads_data_redirection",true);' : '';
  return `${consentScript}(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='${url}/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f)})(window,document,'script','dataLayer','${containerId}');`;
};
export const getNoscriptSnippet = (containerId, url = GTM_URL) => `<noscript><iframe src="${url}/ns.html?id=${containerId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`;
const createScript = (containerId, url, consentMode) => {
  const content = getJavascriptSnippet(containerId, url, consentMode);
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = `gtm-container-${containerId}`;
  script.append(document.createTextNode(content));
  return script;
};
const isContainerInjected = containerId => {
  return document.getElementById(`gtm-container-${containerId}`) !== null;
};
export const injectGTMSnippet = (containerId, url = GTM_URL, consentMode = false) => {
  if (!isContainerInjected(containerId)) {
    const script = createScript(containerId, url, consentMode);
    if (document.head) {
      document.head.insertBefore(script, document.head.childNodes[0]);
    }
  }
};